(() => {
  const initialize = () => {
    if (!document.body.classList.contains('td-product-page')) return;
    const header = document.querySelector('#header-component');
    if (!header) return;
    let frame = 0;
    const measure = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const height = Math.ceil(header.getBoundingClientRect().height);
        document.body.style.setProperty('--td-product-header-height', height + 'px');
      });
    };
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(header);
    window.addEventListener('pageshow', measure);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, {once:true});
  } else {
    initialize();
  }
})();